import gsap from "gsap";

export default class Marquee {
    constructor() {
        this.marquees = document.querySelectorAll('.marquee');
        if (this.marquees.length) {
            window.addEventListener('load', () => this.init());
        }
    }

    init() {
        this.marquees.forEach((marquee) => {
            const marqueeWrapper = marquee.querySelector(".marquee-wrapper");
            const marqueeTrack = marquee.querySelector(".marquee-track");
            const marqueeItems = Array.from(marquee.querySelectorAll(".marquee-item"));
            const speed = parseFloat(marquee.getAttribute('data-marquee-speed')) || 30;

            if (!marqueeWrapper || !marqueeTrack || marqueeItems.length === 0) return;

            const wrapperWidth = marqueeWrapper.offsetWidth;
            let totalWidth = marqueeTrack.scrollWidth;

            const maxClones = 3;
            let clones = 0;

            while (totalWidth < wrapperWidth * 2 && clones < maxClones) {
                marqueeItems.forEach(item => {
                    const clone = item.cloneNode(true);
                    marqueeTrack.appendChild(clone);
                });
                totalWidth = marqueeTrack.scrollWidth;
                clones++;
            }

            const marqueeWidth = totalWidth / 2;

            gsap.set(marqueeTrack, { x: 0, y: 0, rotate: 0, scale: 1 });

            const marqueeAnimation = gsap.to(marqueeTrack, {
                x: -marqueeWidth,
                duration: speed,
                ease: "linear",
                repeat: -1,
            });

            marqueeWrapper.addEventListener("mouseenter", () => marqueeAnimation.pause());
            marqueeWrapper.addEventListener("mouseleave", () => marqueeAnimation.play());

            this.animateArrows(marquee);
        });

    }
    animateArrows(marquee) {
        const arrows = marquee.querySelectorAll('.arrow');

        arrows.forEach((arrow, index) => {
            gsap.to(arrow, {
                rotation: 360,
                duration: 8,
                repeat: -1,
                ease: 'linear',
                transformOrigin: '50% 50%',
                delay: (index * (90 / 360)) * 8,
            });
        });
    }
}
